// extracted by mini-css-extract-plugin
export default {"container":"Dialogue_container__KEown","content":"Dialogue_content__8qZEY"};